import React, { Component } from "react";

export default class GenAIImg extends Component {
  render() {
    const theme = this.props.theme;
    return (
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 800 500"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <radialGradient id="brainGradient" cx="50%" cy="50%" r="60%">
            <stop offset="0%" stopColor={theme.jacketColor || "#fff"} stopOpacity="0.95" />
            <stop offset="100%" stopColor={theme.imageHighlight || "#645beb"} stopOpacity="0.25" />
          </radialGradient>
          <linearGradient id="nodeGradient" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor={theme.text || "#645beb"} stopOpacity="0.8" />
            <stop offset="100%" stopColor={theme.imageHighlight || "#645beb"} stopOpacity="0.2" />
          </linearGradient>
        </defs>
        {/* Background */}
        <rect width="800" height="500" rx="40" fill={theme.compImgHighlight || "#f5f6fa"} />
        {/* Realistic brain shape */}
        <ellipse cx="400" cy="250" rx="140" ry="100" fill="url(#brainGradient)" />
        {/* Brain folds (gyri) */}
        <path d="M320 250 Q340 180 400 200 Q460 220 480 250 Q500 280 440 300 Q380 320 340 280 Q320 260 320 250 Z" fill="none" stroke={theme.text || "#645beb"} strokeWidth="4" opacity="0.18" />
        <path d="M370 220 Q390 210 410 230 Q430 250 420 270 Q410 290 390 270 Q370 250 370 220 Z" fill="none" stroke={theme.text || "#645beb"} strokeWidth="3" opacity="0.18" />
        {/* Neural network nodes */}
        <circle cx="340" cy="210" r="12" fill="url(#nodeGradient)" />
        <circle cx="460" cy="220" r="12" fill="url(#nodeGradient)" />
        <circle cx="370" cy="320" r="10" fill="url(#nodeGradient)" />
        <circle cx="430" cy="320" r="10" fill="url(#nodeGradient)" />
        <circle cx="400" cy="250" r="14" fill="url(#nodeGradient)" />
        {/* Node connections */}
        <line x1="340" y1="210" x2="400" y2="250" stroke={theme.text || "#645beb"} strokeWidth="2" opacity="0.25" />
        <line x1="460" y1="220" x2="400" y2="250" stroke={theme.text || "#645beb"} strokeWidth="2" opacity="0.25" />
        <line x1="370" y1="320" x2="400" y2="250" stroke={theme.text || "#645beb"} strokeWidth="2" opacity="0.25" />
        <line x1="430" y1="320" x2="400" y2="250" stroke={theme.text || "#645beb"} strokeWidth="2" opacity="0.25" />
        {/* Chat/message motifs */}
        <rect x="500" y="180" rx="10" width="60" height="28" fill={theme.imageHighlight || "#645beb"} opacity="0.18" />
        <rect x="250" y="300" rx="10" width="60" height="28" fill={theme.imageHighlight || "#645beb"} opacity="0.18" />
        {/* Decorative digital dots */}
        <circle cx="520" cy="194" r="6" fill={theme.text || "#645beb"} opacity="0.18" />
        <circle cx="270" cy="314" r="6" fill={theme.text || "#645beb"} opacity="0.18" />
        {/* Subtle highlight */}
        <ellipse cx="400" cy="230" rx="60" ry="18" fill="#fff" opacity="0.12" />
      </svg>
    );
  }
} 